/**
 * Project view sidebar (v2.5 UX overhaul).
 *
 * Replaces the horizontal TabNav with a persistent left sidebar
 * containing Overview / Documents / Conversations / Jobs. Each item
 * renders as a NavLink so active state is driven by the URL.
 */

import { NavLink } from "react-router-dom";

export default function ProjectSidebar({ sections }) {
  return (
    <nav className="project-sidebar" aria-label="Project sections">
      {sections.map((s) => (
        <NavLink
          key={s.to}
          to={s.to}
          end={s.end}
          className={({ isActive }) =>
            `sidebar-item${isActive ? " sidebar-item--active" : ""}`
          }
        >
          <span className="sidebar-item__label">{s.label}</span>
          {s.count != null && (
            <span className="sidebar-item__count">{s.count}</span>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
